import React, { useState, useCallback, memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';

import CustomButton from 'components/CustomButton';
import Timer from './Timer';
import { CasemasterAssessmentStates } from './constant';
import useCaseMasterStore from './CaseMasterStore';
import ConfirmationDialog from 'dialogs/ConfirmationDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '76px',
    padding: theme.spacing(4, 5),
    borderBottom: `1px solid ${theme.palette.neutral['clr-200']}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    top: 0,
    backgroundColor: theme.palette.common.white,
    zIndex: 1000,
    boxShadow: `0px 0px 9px 0px #02569D1A`

  },
  name: {
    display: 'flex',
    width: '33.33%',
    alignItems: 'center',
  },
  title: {
    color: '#4E5661',
  },
  action: {
    display: 'flex',
    width: '33.33%',
    justifyContent: 'flex-end',
    position: 'relative',
    paddingRight : '20px'
  },
  timerBox: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  }
}));

const Header = memo(() => {
  const classes = useStyles();
  const [openEndDialog, setOpenEndDialog] = useState(false);

  const assessmentState = useCaseMasterStore(state => state.assessmentState);
  const setAssessmentState = useCaseMasterStore(state => state.setAssessmentState);
  const casemasterProblem = useCaseMasterStore(state => state.casemasterProblem);
  const hasGivenResponse = useCaseMasterStore(state => state.hasGivenResponse);

  const handleEndAssessment = useCallback(() => {
    setOpenEndDialog(false);
    setAssessmentState(CasemasterAssessmentStates.FINISHING);
  }, [setAssessmentState]);

  const handleCloseDialog = useCallback(() => {
    setOpenEndDialog(false);
  }, []);

  const handleOpenDialog = useCallback(() => {
    setOpenEndDialog(true);
  }, []);

  return (
    <Box className={classes.root}>
      <Box className={classes.name}>
        <Typography variant="h5-medium" className={classes.title}>
          {casemasterProblem?.title || 'Case Problem Topic'}
        </Typography>
      </Box>

      {![
        CasemasterAssessmentStates.FULL_SCREEN_PERMISSION,
        CasemasterAssessmentStates.FETCHING_CASEMASTER_PROBLEM
      ].includes(assessmentState) && (
        <Box id="case-timer-container" className={classes.timerBox}>
          <Box id="case-timer">
            <Timer
              totalTime={1800}
              warningTime={60}
            />
          </Box>
        </Box>
      )}

      <Box className={classes.action}>
        <CustomButton
          variant='outlined'
          size='medium'
          startIcon={<CloseIcon />}
          onClick={handleOpenDialog}
          disabled={!hasGivenResponse}
        >
          <Box>End Session</Box>
        </CustomButton>
      </Box>

      <ConfirmationDialog
        open={openEndDialog}
        title="End Case Study Interview?"
        message="Are you sure you want to end this case study interview? Your progress will be saved and you won't be able to continue."
        onClose={handleCloseDialog}
        primaryAction="Yes, End Interview"
        secondaryAction="Cancel"
        onPrimaryAction={handleEndAssessment}
        onSecondaryAction={handleCloseDialog}
      />
    </Box>
  );
});

export default Header;
